module.exports = __webpack_public_path__ + "img/kdIcon2.5e52c0ad.png";